import ArtRoom from '../pages/tours/ArtRoom';
import Preload from '../components/Preload';
import FadeIn from '../components/FadeIn';

function Home() {
    const preloadResources = {
        images: [
            {
                src: `${process.env.PUBLIC_URL}/images/banner01.avif`,
                media: "(min-width: 768px)"
            },

            {
                src: `${process.env.PUBLIC_URL}/images/banner01m.avif`,
                media: "(max-width: 767px)"
            }

        ]
    };

    return (
      <>
      <Preload {...preloadResources} />
      {/* headers  */}
        <title>vidi3D - Virtual Sales Toolkit for Venues and Event Spaces</title>
        <meta name="description" content="Transform your venue sales with vidi3D's immersive 3D walkthroughs, event space virtualization, and interactive layout customization. Increase bookings and client satisfaction." />
        <meta name="keywords" content="3D venue tours, virtual event spaces, venue visualization, event layout planning, virtual sales toolkit" />
        <meta property="og:title" content="vidi3D - Virtual Sales Toolkit for Venues and Event Spaces" />
        <meta property="og:description" content="Transform your venue sales with vidi3D's immersive 3D walkthroughs, event space virtualization, and interactive layout customization." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/banner01.jpg`} />
        <link rel="canonical" href="https://vidi3d.com" />

        <div className="flex flex-col items-center w-full mx-auto">
          {/* banner */}
            <div className="relative w-full h-[60vh] mb-16">
                <picture>
                    <source 
                        media="(max-width: 767px)"
                        srcSet={`${process.env.PUBLIC_URL}/images/banner01m.avif`}
                    />
                    <source 
                        media="(min-width: 768px)"
                        srcSet={`${process.env.PUBLIC_URL}/images/banner01.avif`}
                    />
                    <img 
                        src={`${process.env.PUBLIC_URL}/images/banner01.avif`}
                        alt="Banner" 
                        className="w-screen h-full object-cover brightness-50"
                    />
                </picture>
                <div className="absolute inset-0 flex flex-col items-center justify-center px-4 w-full max-w-[1200px] mx-auto">
                    <FadeIn>
                    <h1 className="text-4xl md:text-6xl font-bold text-white text-center max-w-4xl drop-shadow-2xl mb-12">
                        Your virtual sales toolkit for all venues, event setups and layouts
                    </h1>
                    </FadeIn>
                    <FadeIn delay={0.25}>
                    <a href="/contact" className="bg-brand hover:bg-brand-dark transition-colors duration-300 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg">
                        Get in touch
                    </a>
                    </FadeIn>
                </div>
            </div>

            {/* title + experience */}
            <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
            <FadeIn delay={0.4}>
            <h1 className="text-6xl font-bold text-brand text-center py-10">Bring your venue to life: customize, visualize, and increase your bookings with vidi3D</h1>
            </FadeIn>
            <FadeIn delay={0.5}>
            <p className="text-brand-dark text-center text-xl">Explore limitless design options, elevate your space, impress clients, and increase bookings effortlessly</p>
            </FadeIn>
            <FadeIn delay={0.25}>
            <ArtRoom title="" />
            </FadeIn>
            <FadeIn delay={0.25}>
            <a href="/contact" className="bg-brand hover:bg-brand-dark transition-colors duration-300 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg">Get Started</a>
            </FadeIn>
            {/* <BeforeAfter beforeImage="images/art-room-before.jpg" afterImage="images/art-room-after.jpg" />             */}
        </div>

        {/* video */}
        <div className="w-full max-w-[1200px] mx-auto mt-16">
        <FadeIn delay={0.25}>
          <div className="relative w-full max-w-[600px] mx-auto aspect-video">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube-nocookie.com/embed/FLC4DbxGeZU"
              title="vidi3D Demo Video" 
              frameBorder="0"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          </FadeIn>
          </div>

        {/* solutions */}
        <section className="w-full max-w-[1200px] mx-auto mt-16 px-4">
            <FadeIn delay={0.25}>
            <h2 className="text-6xl font-bold text-brand text-center mb-6">Our 3D solutions</h2>
            </FadeIn>
            <FadeIn delay={0.5}>
            <p className="text-brand-dark text-center text-xl mb-12">Empower your sales team with immersive event setups that showcase captivating experiences and drive client engagement</p>
            </FadeIn>
            <div className="grid md:grid-cols-3 gap-8">
            {/* Solution 1 */}
            <FadeIn delay={0.15}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Immersive 3D Walkthrough</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-01.avif`} alt="3D Walkthrough" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">Create a custom 3D walkthrough. Elevate your event space with custom 3D walkthroughs</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>

            {/* Solution 2 */}
            <FadeIn delay={0.3}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Event Space Virtualization</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-02.avif`} alt="Event Space" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">Event space 3D rendering. Transform reality into virtual experiences and engage clients with our 3D technology</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>

            {/* Solution 3 */}
            <FadeIn delay={0.45}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Photo-realistic 3D Renderings</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-03.avif`} alt="3D Renderings" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">High quality 3D renderings. High quality renderings that bring your client's vision to life</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>

            {/* Solution 4 */}
            <FadeIn delay={0.15}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Custom Furniture Modelling</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-04.avif`} alt="Custom Furniture" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">Virtual tour staging and custom furniture. Effortless virtual staging and custom furniture modeling to bring your vision to life</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>

            {/* Solution 5 */}
            <FadeIn delay={0.3}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Interactive Layout Customization</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-05.avif`} alt="Layout Customization" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">Customized layouts. Unlock endless setup possibilities with our digital navigator</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>

            {/* Solution 6 */}
            <FadeIn delay={0.45}>
            <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Web Implementation & Hosting</h3>
                <img src={`${process.env.PUBLIC_URL}/home/3d-solutions-06.avif`} alt="Web Implementation" className="w-full h-48 object-cover rounded-lg mb-4"/>
                <p className="text-gray-600 mb-4">Walkthrough ipad setup. Seamless web embed to boost your client visibility & strengthen external partnerships</p>
                <a href="/contact" className="text-brand hover:text-brand-dark font-semibold">Learn more →</a>
            </div>
            </FadeIn>
            </div>
        </section>

        {/* benefits */}
        <section className="w-full py-16">
            <div className="text-center mb-12">
            <FadeIn delay={0.25}>
            <h2 className="text-6xl font-bold text-brand mb-4">The benefits</h2>
            </FadeIn>
            <FadeIn delay={0.5}>
            <p className="text-xl text-brand-dark">Boost booking by showing custom event setups, layout and services specifically adapted to your space</p>
            </FadeIn>
            </div>

            <div className="grid md:grid-cols-4 gap-8 max-w-7xl mx-auto px-4">
            {/* Benefit 1 */}
            <FadeIn delay={0.15}>
            <div className="flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">More qualified leads</h3>
                <p className="text-xl font-bold text-brand-dark mb-4">+35% increase in inquiries</p>
                <p className="text-gray-600 mt-auto">Maximize pre-visit experience online bringing more leads for site visits</p>
            </div>
            </FadeIn>

            {/* Benefit 2 */}
            <FadeIn delay={0.3}>
            <div className="flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Increased bookings on the spot</h3>
                <p className="text-xl font-bold text-brand-dark mb-4">4X faster decision-making</p>
                <p className="text-gray-600 mt-auto">Virtual tours help speed up the booking process</p>
            </div>
            </FadeIn>

            {/* Benefit 3 */}
            <FadeIn delay={0.45}>
            <div className="flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Increased upsells</h3>
                <p className="text-xl font-bold text-brand-dark mb-4">+85% improved client satisfaction</p>
                <p className="text-gray-600 mt-auto">Alleviate complexities in conveying space to potential clients online</p>
            </div>
            </FadeIn>

            {/* Benefit 4 */}
            <FadeIn delay={0.6}>
            <div className="flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 mb-4 text-brand">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                </svg>
                </div>
                <h3 className="text-xl font-bold text-brand mb-2">Outshine competition</h3>
                <p className="text-xl font-bold text-brand-dark mb-4">+51% increase conversion rates</p>
                <p className="text-gray-600 mt-auto">Clients feel more informed and confident after a virtual tour</p>
            </div>
            </FadeIn>
            </div>
        </section>
      {/* product & services */}
      <section className="w-full max-w-[1200px] mx-auto mt-16 px-4">
          <FadeIn delay={0.25}>
          <h2 className="text-6xl font-bold text-brand text-center mb-6">Our product & services</h2>
          </FadeIn>
          <FadeIn delay={0.5}>
          <p className="text-brand-dark text-center text-xl mb-12">Unlock your venue's full potential allowing your sales team to thrive</p>
          </FadeIn>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
              {/* Left Column */}
              <div className="space-y-8">
                <FadeIn delay={0.15}>
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                      <h3 className="text-xl font-bold text-brand mb-2">Virtual Venue Explorer</h3>
                      <p className="text-gray-600 mb-2 font-semibold">Offers immersive 3D walkthroughs</p>
                      <p className="text-gray-600">Users can explore venues from any device, providing a real-time, interactive experience</p>
                  </div>
                </FadeIn>
                <FadeIn delay={0.3}>
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                      <h3 className="text-xl font-bold text-brand mb-2">Dynamic Link Generator</h3>
                      <p className="text-gray-600 mb-2 font-semibold">Amplify access & visibility</p>
                      <p className="text-gray-600">Generates unique, shareable URLs making it easy for event managers and clients to review and discuss setups on-site</p>
                  </div>
                </FadeIn>
              </div>

              {/* Center Column - Only visible on large screens */}
              <FadeIn delay={0.45}>
              <div className="hidden lg:flex flex-col items-center justify-center h-full">
                  
                  <img 
                      src={`${process.env.PUBLIC_URL}/room-layouts.gif`}
                      alt="Product Demo" 
                      className="w-full rounded-lg mb-6"
                  />
                  <a href="/contact" className="bg-brand hover:bg-brand-dark transition-colors duration-300 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg">
                      Schedule a Demo
                  </a>
              </div>
              </FadeIn>

                {/* Center Column - Only visible on mobile/tablet */}
                <div className="md:col-span-2 lg:hidden flex flex-col items-center justify-center">
                  <FadeIn delay={0.45}>
                  <img 
                      src={`${process.env.PUBLIC_URL}/room-layouts.gif`}
                      alt="Product Demo" 
                      className="w-full max-w-md rounded-lg mb-6"
                  />
                  </FadeIn>
              </div>


              {/* Right Column */}
              <div className="space-y-8">
                <FadeIn delay={0.6}>
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                      <h3 className="text-xl font-bold text-brand mb-2">Customization Dashboard</h3>
                      <p className="text-gray-600 mb-2 font-semibold">Offers customization in real-time</p>
                      <p className="text-gray-600">An easy-to-use interface that allows event managers to tailor event setups and layouts according to client needs</p>
                  </div>
                </FadeIn>
                <FadeIn delay={0.75}>
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                      <h3 className="text-xl font-bold text-brand mb-2">Analytics and Insights Hub</h3>
                      <p className="text-gray-600 mb-2 font-semibold">Coming soon</p>
                      <p className="text-gray-600">A robust analytics tool that tracks user interactions with the virtual tour, offering insights into client preferences and engagement</p>
                  </div>
                </FadeIn>
              </div>

                {/* Center Column - Only visible on mobile/tablet */}
                <div className="md:col-span-2 lg:hidden flex flex-col items-center justify-center">
                  <FadeIn delay={0.45}>
                  <a href="/contact" className="bg-brand hover:bg-brand-dark transition-colors duration-300 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg">
                      Schedule a Demo
                  </a>
                  </FadeIn>
              </div>
          </div>
      </section>
      <section className="w-full py-16">
          <FadeIn delay={0.25}>
          <h2 className="text-6xl font-bold text-brand text-center mb-4">How does it work?</h2>
          </FadeIn>
          <FadeIn delay={0.5}>
          <p className="text-xl text-brand-dark text-center mb-12">Seamlessly integrate our tech from onboarding to design, delivering an interactive 3D experience for your event space</p>
          </FadeIn>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto mb-12">
              {/* Item 1 */}
              <FadeIn delay={0.15}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">Onboarding</h3>
                  <p className="text-gray-600">Providing accurate, scaled layouts helps us recreate the space's dimensions and configurations</p>
              </div>
              </FadeIn>

              {/* Item 2 */}
              <FadeIn delay={0.3}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21 6h-4c0-2.76-2.24-5-5-5S7 3.24 7 6H3v14h18V6zm-9-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 15H5V8h14v10z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">Free Design Consultancy</h3>
                  <p className="text-gray-600">Offering a free design aligns the virtual tour with venue goals, builds trust, and enhances collaboration</p>
              </div>
              </FadeIn>

              {/* Item 3 */}
              <FadeIn delay={0.45}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">3D Design & Rendering</h3>
                  <p className="text-gray-600">Use specialized software to create a precise 3D model, incorporating assets to mirror the venue</p>
              </div>    
              </FadeIn>

              {/* Item 4 */}
              <FadeIn delay={0.15}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">Custom vidi3D Tech</h3>
                  <p className="text-gray-600">Our creative team places 3D models of furniture and fixtures to accurately reflect the design and functionality of the space</p>
              </div>
              </FadeIn>

              {/* Item 5 */}
              <FadeIn delay={0.3}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">Coding + Web Publishing</h3>
                  <p className="text-gray-600">Optimize and host the 3D model for fast loading and smooth interaction</p>
              </div>
              </FadeIn>

              {/* Item 6 */}
              <FadeIn delay={0.45}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full">
                  <svg className="w-12 h-12 text-brand mb-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                  </svg>
                  <h3 className="text-xl font-bold text-brand-dark mb-2">Support</h3>
                  <p className="text-gray-600">Offer ongoing web management with updates, support, and monitoring to ensure the virtual space stays functional</p>
              </div>
              </FadeIn>
          </div>

          <div className="flex justify-center">
              <FadeIn delay={0.5}>
              <a href="/contact" className="bg-brand hover:bg-brand-dark transition-colors duration-300 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg">
                  Learn More
              </a>
              </FadeIn>
          </div>
      </section>
      </div>
      </>
    );
  }
  
  export default Home;